import axios from 'axios'
import Cookies from 'js-cookie'

import { appConfig } from '../../configs/env-config.js'
// import * as utils from '../utils.js'

const apiRoute = appConfig.REACT_APP_UrlApi

const CancelToken = axios.CancelToken
let cancel

const axiosInstance = axios.create({
  validateStatus: function(status) {
    return status !== 404 && status < 500  // Retorna verdadeiro para códigos de status 2xx
  }
})

axiosInstance.interceptors.request.use(
  async function(config) {
    const token = Cookies.get('TradeTalentosTokenPAT')
    // Do something before request is sent
    let newConfig = {}
    if (config) {
      newConfig = config
    }
    if (newConfig.url.startsWith(apiRoute)) {
      newConfig.headers = {
        ...newConfig.headers,
        Authorization: `Bearer ${token}`
      }
    }
    return newConfig
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error)
  }
)
// Quem quiser saber que algo foi gravado (por exemplo, para esquecer dados em memória que ficaram velhos).
const aoGravar = new Set()
export const quandoGravar = fn => {
  aoGravar.add(fn)
  return () => aoGravar.delete(fn)
}
const gravou = response => {
  const metodo = String(response?.config?.method || 'get').toLowerCase()
  if (metodo === 'get' || response.status >= 300 || !String(response.config?.url || '').startsWith(apiRoute)) return
  aoGravar.forEach(fn => { try { fn() } catch (e) { /* quem ouve não pode derrubar a chamada */ } })
}

axiosInstance.interceptors.response.use(
  function(response) {
    let newResponse = {}
    if (response) {
      newResponse = response
      gravou(response)
    }
    return newResponse
  },
  function(error) {
    //const statusError = [403, 401]
    // if (statusError.includes(error.response.status)) {
    //   storage.clear()
    //   return
    // }
    return Promise.reject(error)
  }
)

// export const sendWithAxiosCancelPrev = async (url, method, payload) => {
//   if (cancel !== undefined) {
//     cancel()
//   }
//   try {
//     const result = await axios({
//       url,
//       method,
//       data: payload,
//       cancelToken: new CancelToken(function executor(c) {
//         cancel = c
//       })
//     })
//     if (result.status >= 300) {
//       return {
//         data: false,
//         fail: true,
//         status: result.status,
//         error: result.data.message
//       }
//     }
//     return { data: result.data, fail: null, status: result.status }
//   } catch (error) {
//     const errors = parseError(error)
//     return { data: false, fail: true, errors }
//   }
// }

// Erro 500 do Portal vem como { erro, detalhe } (o detalhe só para quem administra o BI).
// As telas antigas leem só "message"; sem isto, a causa some atrás de uma frase genérica.
const mensagemDoServidor = data => {
  if (!data || typeof data !== 'object') return undefined
  if (data.message) return data.message
  if (data.erro) return data.detalhe ? `${data.erro} (${data.detalhe})` : data.erro
  return undefined
}

// O corpo de erro de uma resposta binária chega como bytes: lê o { erro } do portal, se for isso.
const mensagemDeBytes = data => {
  try {
    if (!data || !data.byteLength) return undefined
    return mensagemDoServidor(JSON.parse(new TextDecoder().decode(data)))
  } catch {
    return undefined
  }
}

// Baixa um arquivo (imagem) com o token do portal. Devolve { data: ArrayBuffer, tipo } ou { fail, error, status }.
export const sendBinario = async url => {
  try {
    const result = await axiosInstance({ url, method: 'GET', responseType: 'arraybuffer' })
    if (result.status >= 300) {
      return { data: false, fail: true, status: result.status, error: mensagemDeBytes(result.data) }
    }
    return { data: result.data, fail: null, status: result.status, tipo: result.headers?.['content-type'] }
  } catch (error) {
    return { data: false, fail: true, status: error?.response?.status, error: mensagemDeBytes(error?.response?.data) }
  }
}

export const sendWithAxios = async (url, method, payload) => {
  try {
    const result = await axiosInstance({
      url,
      method,
      data: payload
    })
    if (result.status === 400) {

      console.log(result)
      if (result.data.errors) {
        return {
          data: false,
          fail: true,
          status: result.status,
          error: result.data.errors.toString()
        }
      }

      if (result.data) {
        let message = ''
        Object.values(result.data).forEach(array => {
          array.forEach(item => {
            message += item + '||'
          })
        })

        return {
          data: false,
          fail: true,
          status: result.status,
          error: message
        }
      }

    }
    if (result.status === 401) {
      return {
        data: false,
        fail: true,
        status: result.status,
        error: mensagemDoServidor(result.data)
      }
    }
    if (result.status >= 300) {
      return {
        data: false,
        fail: true,
        status: result.status,
        error: mensagemDoServidor(result.data)
      }
    }
    return { data: result.data, fail: null, status: result.status }
  } catch (error) {
    const errors = parseError(error)
    const status = error?.response?.status
    if (status === 400) {
      return {
        data: false,
        fail: true,
        status: status,
        error: error?.response?.data ? JSON.stringify(error.response.data) : `Error: ${status} `
        //error: error?.response?.data ? error.response.data : `Error: ${status} `
      }
    }
    const errorString = mensagemDoServidor(error?.response?.data)
    return { data: false, fail: true, error: errorString ? errorString : errors, status: status }
  }
}

export const sendWithAxiosString = async (url, method, payload) => {
  try {
    const result = await axios({
      url,
      method,
      headers: { 'Content-type': 'application/json' },
      data: payload
    })
    if (result.status >= 300) {
      return {
        data: false,
        fail: true,
        status: result.status,
        error: result.data.message
      }
    }
    return { data: result.data, fail: null, status: result.status }
  } catch (error) {
    const errors = parseError(error)
    return { data: false, fail: true, error: errors }
  }
}
export const sendWithAxiosBlob = async (url, method, payload) => {
  try {
    // var formData = new FormData();
    // formData.append("file", payload);
    let result
    if (method === 'POST') {
      result = await axios({
        url,
        method,
        data: payload,
        headers: {
          'Content-Type': 'application/octet-stream'
        }
      })
    } else {
      result = await axios({
        url,
        method,
        data: payload,
        headers: {
          'Content-Type': 'application/octet-stream'
        }
      })
    }

    if (result.status >= 300) {
      return {
        data: false,
        fail: true,
        status: result.status,
        error: result.data.message
      }
    }
    return { data: result.data, fail: null, status: result.status }
  } catch (error) {
    const errors = parseError(error)
    return { data: false, fail: true, error: errors }
  }
}

export const parseError = errors => {
  try {
    let error = ''
    const { response, isAxiosError } = errors
    const { data } = response

    if (data) {
      let msg = ''
      if (data.error) {
        msg = data.error
      } else if (data.errors) {
        msg = data.errors[Object.keys(data.errors)[0]]
      }
      error = msg ? msg : ''
      return error
    } else if (isAxiosError) {
      throw new Error()
    }
    throw new Error()

  } catch (error) {
    return 'Falha na comunicação com o servidor'
  }
}

/**
 * Chamada JSON que entende o formato de erro { erro: "mensagem" }.
 *
 * O sendWithAxios espera no 400 um objeto de listas (o formato do FluentValidation) e
 * quebra com uma mensagem simples. As rotas dos relatórios HTML respondem 400, 403,
 * 409 e 502 sempre com { erro }, e é essa frase que a tela precisa mostrar — ela foi
 * escrita para quem está montando o relatório entender o que corrigir.
 */
export const sendJson = async (url, method, payload) => {
  try {
    const result = await axiosInstance({ url, method, data: payload })
    if (result.status >= 300) {
      return {
        data: false,
        fail: true,
        status: result.status,
        error: result.data?.erro || result.data?.message || `Erro ${result.status}`
      }
    }
    return { data: result.data, fail: null, status: result.status }
  } catch (error) {
    const status = error?.response?.status
    const corpo = error?.response?.data
    return {
      data: false,
      fail: true,
      status,
      error: corpo?.erro || corpo?.message || (status ? `Erro ${status}` : 'Sem resposta do servidor')
    }
  }
}
